var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('LoginModal',{attrs:{"customClass":'loginPageModal',"onLoginSuccessHandler":_vm.onLoginSuccessHandler,"isShow":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }